import script from "./CommerceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CommerceSettings.vue?vue&type=script&setup=true&lang=js"

import "./CommerceSettings.vue?vue&type=style&index=0&id=6e7ca86d&scoped=true&lang=css"
import "./CommerceSettings.vue?vue&type=style&index=1&id=6e7ca86d&lang=css"
import "./CommerceSettings.vue?vue&type=style&index=2&id=6e7ca86d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e7ca86d"]])

export default __exports__